import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            d="M12 3a.7.7 0 0 1 .633.4l2.438 5.145 5.32.703a.7.7 0 0 1 .423 1.168l-3.808 4.125 1.05 5.63a.7.7 0 0 1-1.002.754L12 18.384l-5.054 2.541a.7.7 0 0 1-1.002-.753l1.05-5.631-3.808-4.125a.7.7 0 0 1 .422-1.168l5.321-.703L11.367 3.4A.7.7 0 0 1 12 3Z"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
